import { ResponseGetFamily } from "@/actions/parents/parents.interface";
import { getEditFamily } from "@/actions/parents/parentsa.api";
import { create } from "zustand";

interface State {
    yearId: string;
    campusId: string;
    levelId: string,

    setYear: (value: string) => void,
    setCampus: (value: string) => void,
    setLevel: (value: string) => void,

}

export const globalStorage = create<State>()((set) => ({
    yearId: "",
    campusId: "",
    levelId: "",
    setYear: (value) => set({ yearId: value }),
    setCampus: (value) => set({ campusId: value }),
    setLevel: (value) => set({ levelId: value }),
}));

